import { render, staticRenderFns } from "./uklon_market_general_tab.vue?vue&type=template&id=34ebd9b8&scoped=true&"
import script from "./uklon_market_general_tab.vue?vue&type=script&lang=js&"
export * from "./uklon_market_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ebd9b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ebd9b8')) {
      api.createRecord('34ebd9b8', component.options)
    } else {
      api.reload('34ebd9b8', component.options)
    }
    module.hot.accept("./uklon_market_general_tab.vue?vue&type=template&id=34ebd9b8&scoped=true&", function () {
      api.rerender('34ebd9b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/uklon_market_general_tab.vue"
export default component.exports